import React, { useEffect, useState } from "react";
import CallCut from "assets/svgs/call_cut.js";
import CallIcon from "assets/svgs/table_call";
import { useCall } from "modules/dashboards/actionables/store";
import { useToast } from "modules/navbar/top/store/toasterStore";
import Table from "./Table";

function MedRepBookings({ medRepBookingData }) {
  const { call } = useCall();
  const { setToaster } = useToast();
  const [callIcons, setCallIcons] = useState({});

  useEffect(() => {
    const icons = {};
    medRepBookingData &&
      medRepBookingData.length &&
      medRepBookingData.forEach((booking) => {
        icons[booking.case.id] = <CallIcon />;
      });
    setCallIcons(icons);
  }, [medRepBookingData]);

  const handleCall = (caseId, taskId, phoneNumber) => {
    call(caseId, null, taskId, phoneNumber, setToaster);
    setCallIcons((prevIcons) => ({
      ...prevIcons,
      [caseId]: <CallCut />,
    }));
  };
  return medRepBookingData && medRepBookingData.length ? (
    <Table data={medRepBookingData} handleCall={handleCall} callIcons={callIcons}/>
  ) : (
    <div>No Booking available</div>
  );
}

export default MedRepBookings;
